(() => {
  if (window.monoreeRestockBridgeInstalled) return;
  window.monoreeRestockBridgeInstalled = true;

  const triggerSelector = '[data-monoree-restock]';
  const popupSelector = '.restock-alerts-modal-box';
  const submitSelector = '.restock-alerts-submit-button';
  const blockedButtons = new WeakMap();
  const accessiblePopups = new WeakSet();
  const copy = JSON.parse(document.getElementById('MonoreeAppCopy')?.textContent || '{}');
  let active = null;

  function enhancePopup(popup, owner) {
    const dialog = popup.closest('dialog, [role="dialog"]') || popup;
    if (!dialog.matches('dialog')) {
      dialog.setAttribute('role', 'dialog');
      dialog.setAttribute('aria-modal', 'true');
    }
    const title = popup.querySelector('.restock-alerts-form-title');
    if (title) {
      if (!title.id) title.id = 'MonoreeRestockTitle';
      dialog.setAttribute('aria-labelledby', title.id);
    } else if (copy.notify) dialog.setAttribute('aria-label', copy.notify);
    const select = popup.querySelector('.restock-alerts-variant-select');
    if (select && copy.variant) select.setAttribute('aria-label', copy.variant);
    const email = popup.querySelector('.restock-alerts-email-input');
    const label = popup.querySelector('.restock-alerts-email-label');
    if (email) {
      if (!email.id) email.id = 'MonoreeRestockEmail';
      if (label) label.setAttribute('for', email.id);
      email.setAttribute('autocomplete', 'email');
      email.setAttribute('inputmode', 'email');
    }
    const close = popup.querySelector('.modal-close-btn');
    if (close) {
      close.setAttribute('role', 'button');
      close.setAttribute('tabindex', '0');
      close.setAttribute('aria-label', copy.close || 'Close');
    }
    if (accessiblePopups.has(popup)) return;
    accessiblePopups.add(popup);
    popup.addEventListener('keydown', (event) => {
      if (event.target.closest('.modal-close-btn') && ['Enter', ' '].includes(event.key)) {
        event.preventDefault();
        close?.dispatchEvent(new MouseEvent('click', { bubbles: true }));
      }
    });
    dialog.addEventListener('close', () => {
      if (owner.trigger?.isConnected) owner.trigger.focus({ preventScroll: true });
    }, { once: true });
  }

  const selectedId = (form) => form?.isConnected && form.dataset.monoreeNotifyAvailable === 'true'
    ? form.dataset.monoreeSelectedVariantId || '' : '';

  function setBlocked(popup, blocked) {
    popup?.querySelectorAll(submitSelector).forEach((button) => {
      if (blocked) {
        if (!blockedButtons.has(button)) blockedButtons.set(button, button.disabled);
        if (!button.disabled) button.disabled = true;
      } else if (blockedButtons.has(button)) {
        button.disabled = blockedButtons.get(button);
        blockedButtons.delete(button);
      }
    });
  }

  function showError(owner) {
    const message = owner.form.querySelector('[data-monoree-variant-message]');
    if (message) {
      if (!owner.form.monoreeNotifyFeedback) {
        owner.form.monoreeNotifyFeedback = { text: message.textContent, hidden: message.hidden };
      }
      message.textContent = owner.form.dataset.monoreeNotifyError || '';
      message.hidden = !message.textContent;
    }
  }

  function clearError(form) {
    const previous = form.monoreeNotifyFeedback;
    const message = form.querySelector('[data-monoree-variant-message]');
    if (previous && message?.textContent === form.dataset.monoreeNotifyError) {
      message.textContent = previous.text;
      message.hidden = previous.hidden;
    }
    delete form.monoreeNotifyFeedback;
  }

  function invalidate(owner, error = false) {
    if (active !== owner) return;
    owner.invalidated = true;
    owner.ready = false;
    clearTimeout(owner.timeout);
    clearInterval(owner.monitor);
    setBlocked(owner.popup, true);
    if (error && selectedId(owner.form)) showError(owner);
    if (owner.popup && !owner.closing) {
      owner.closing = true;
      owner.popup.querySelector('.modal-close-btn')?.dispatchEvent(new MouseEvent('click', { bubbles: true }));
    }
  }

  function confirm(owner, select) {
    const targetId = owner.targetId;
    const revision = owner.confirmRevision = (owner.confirmRevision || 0) + 1;
    requestAnimationFrame(() => requestAnimationFrame(() => {
      if (active !== owner || owner.invalidated || owner.confirmRevision !== revision) return;
      owner.syncing = false;
      if (selectedId(owner.form) !== owner.baseId || !owner.popup?.isConnected || owner.targetId !== targetId ||
          owner.select !== select || (select && (!select.isConnected || select.value !== targetId))) {
        reconcile();
        return;
      }
      owner.ready = true;
      clearTimeout(owner.timeout);
      setBlocked(owner.popup, false);
    }));
  }

  function reconcile() {
    if (!active) return;
    const owner = active;
    const popup = document.querySelector(popupSelector);
    if (!popup) {
      if (owner.hasOpened) {
        clearTimeout(owner.timeout);
        clearInterval(owner.monitor);
        active = null;
      }
      return;
    }
    if (owner.popup && owner.popup !== popup) {
      owner.ready = false;
      owner.syncing = false;
      owner.select = null;
    }
    owner.popup = popup;
    owner.hasOpened = true;
    enhancePopup(popup, owner);
    if (owner.invalidated || selectedId(owner.form) !== owner.baseId) {
      invalidate(owner);
      return;
    }
    if (owner.submitting && owner.submissionFramesPassed && popup.style.pointerEvents !== 'none') {
      owner.submitting = false;
    }
    const select = popup.querySelector('select.restock-alerts-variant-select');
    if (owner.ready && owner.select === select && (!select || select.value === owner.targetId)) return;
    setBlocked(popup, true);
    if (owner.select !== select) owner.syncing = false;
    if (owner.syncing) return;
    if (select) {
      const option = [...select.options].find((item) => item.value === owner.targetId && !item.disabled);
      if (!option) return;
      owner.select = select;
      owner.syncing = true;
      const setter = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, 'value').set;
      setter.call(select, owner.targetId);
      owner.dispatchingChange = true;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      owner.dispatchingChange = false;
      confirm(owner, select);
      return;
    }
    const product = window._ReStockConfig?.product;
    const productId = owner.form.closest('product-info')?.dataset.productId;
    if (!productId || String(product?.id) !== productId || product.variants?.length !== 1 ||
        String(product.variants[0].id) !== owner.targetId) return;
    owner.select = null;
    owner.syncing = true;
    confirm(owner, null);
  }

  function ownsCurrentPopup(popup) {
    return active && !active.invalidated && active.ready && active.popup === popup &&
      selectedId(active.form) === active.baseId &&
      (!active.select || active.select.value === active.targetId);
  }

  function canSubmit(popup) {
    return ownsCurrentPopup(popup) && !active.submitting;
  }

  function startSubmission(owner) {
    owner.submitting = true;
    owner.submissionFramesPassed = false;
    requestAnimationFrame(() => requestAnimationFrame(() => {
      if (active !== owner) return;
      owner.submissionFramesPassed = true;
      reconcile();
    }));
  }

  function stop(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest(triggerSelector);
    if (button) {
      const form = button.closest('product-form');
      const id = selectedId(form);
      if (!id || button.disabled || button.closest('quick-add-modal')) {
        stop(event);
        return;
      }
      if (active) {
        clearTimeout(active.timeout);
        clearInterval(active.monitor);
      }
      clearError(form);
      const owner = active = { form, trigger: button, baseId: id, targetId: id, ready: false, syncing: false };
      owner.timeout = setTimeout(() => invalidate(owner, true), 5000);
      owner.monitor = setInterval(reconcile, 100);
      requestAnimationFrame(reconcile);
      return;
    }
    const submit = event.target.closest(submitSelector);
    const popup = submit?.closest(popupSelector);
    if (popup && document.querySelector(triggerSelector)) {
      if (!canSubmit(popup)) {
        stop(event);
        if (!active?.submitting) setBlocked(popup, true);
        reconcile();
      } else {
        // A native submit button produces click AND submit for one activation.
        // Permit that one paired submit without allowing another click/request.
        if (submit.type === 'submit' && submit.form?.closest(popupSelector) === popup) {
          const owner = active;
          const token = owner.nativeSubmit = { form: submit.form, button: submit };
          setTimeout(() => {
            if (owner.nativeSubmit === token) owner.nativeSubmit = null;
          }, 0);
        }
        startSubmission(active);
      }
    }
  }, true);

  document.addEventListener('submit', (event) => {
    const popup = event.target.closest(popupSelector);
    if (popup && document.querySelector(triggerSelector)) {
      const token = active?.nativeSubmit;
      if (token && token.form === event.target && token.button === event.submitter && ownsCurrentPopup(popup)) {
        active.nativeSubmit = null;
        return;
      }
      if (!canSubmit(popup)) stop(event);
      else startSubmission(active);
    }
  }, true);

  document.addEventListener('change', (event) => {
    const select = event.target;
    if (!active || active.dispatchingChange || !select.matches('select.restock-alerts-variant-select') ||
        select.closest(popupSelector) !== active.popup) return;
    const option = select.selectedOptions[0];
    if (!option || option.disabled || !option.value) return;
    active.targetId = option.value;
    active.select = select;
    active.ready = false;
    active.syncing = true;
    setBlocked(active.popup, true);
    confirm(active, select);
  }, true);

  new MutationObserver(reconcile).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-monoree-notify-available', 'data-monoree-selected-variant-id'],
  });
})();
